import { GA_MEASUREMENT_ID, SITE_URL } from './site-config.mjs';

const ANALYTICS_HOST = new URL(SITE_URL).hostname;

let hasStarted = false;

/**
 * Only the canonical host reports. Gating on the hostname rather than
 * NODE_ENV also keeps a production build served locally out of the data.
 */
const isReportingHost = () =>
  typeof window !== 'undefined'
  && Boolean(GA_MEASUREMENT_ID)
  && window.location.hostname === ANALYTICS_HOST;

/**
 * Queues the gtag calls and loads the tag. Calls made before the script
 * arrives are safe: they collect in dataLayer and are replayed on load, so a
 * blocked or slow tag can never throw in a caller.
 */
export function startAnalytics() {
  if (hasStarted || !isReportingHost()) return;
  hasStarted = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // gtag forwards its raw arguments object, so this cannot be an arrow.
    window.dataLayer.push(arguments);
  };

  window.gtag('js', new Date());
  // RouteEffects sends page_view itself. The router swaps pages without
  // reloading the document, so the automatic one would only ever record
  // whichever page a visitor happened to land on first.
  window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });

  const tag = document.createElement('script');
  tag.async = true;
  tag.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(tag);
}

export function trackPageView(path, title) {
  if (typeof window === 'undefined' || !window.gtag) return;

  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: title,
  });
}

export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined' || !window.gtag) return;

  window.gtag('event', name, params);
}

/**
 * Steam links carry rel="noreferrer", so Valve never sees this site as the
 * referrer. This is the only signal we get about which call to action works.
 */
export const trackWishlistClick = (ctaLocation) =>
  trackEvent('wishlist_click', { cta_location: ctaLocation });
